module.exports = __webpack_public_path__ + "img/PL00269.7e30f7d5.png";